import React from 'react';
import { useLanguage } from '../language/LanguageContext';
import SocialLinks from './ui/SocialLinks';

const Footer = () => {
  const { translations } = useLanguage();
  const { footer } = translations;

  return (
    <footer className="mt-20 border-t border-dark-border">
      <div className="max-w-5xl mx-auto px-5 pt-8 pb-24 sm:pb-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <SocialLinks size={18} />
          <p className="text-dark-muted text-sm text-center sm:text-right">
            &copy; {new Date().getFullYear()} Renan Ferreira. {footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
